/** Strip completion link HTML, extract the URL, and return clean text */
export function cleanCompletionLink(raw: string): {
  cleanText: string;
  completionUrl: string | null;
} {
  if (!raw) return { cleanText: '', completionUrl: null };

  const hasCompletionLink = /data-completion-link="true"|>Complete Interview<\/a>/i.test(raw);
  if (!hasCompletionLink) return { cleanText: raw, completionUrl: null };

  // Extract the completion URL. The backend entity-escapes the href
  // (TELV1-551), and this parser reads the RAW stored string rather than
  // a browser-decoded DOM attribute — decode the four escaped entities so
  // links with `&` in the query string stay usable. Older messages with
  // unescaped hrefs decode to themselves (no double-decode input exists:
  // `&amp;amp;` was never written).
  const urlMatch = raw.match(/<a\s[^>]*href="([^"]+)"[^>]*data-completion-link/i);
  const completionUrl = urlMatch?.[1]
    ? urlMatch[1]
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&amp;/g, '&')
    : null;

  // Remove the completion link block and everything after it
  const cleaned = raw
    .replace(/<br\s*\/?>\s*<a\s[^>]*data-completion-link[^>]*>.*?<\/a>[\s\S]*/gi, '')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<[^>]+>/g, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim();

  return { cleanText: cleaned, completionUrl };
}
